import { render, staticRenderFns } from "./ProjectGateCheckIns.vue?vue&type=template&id=0489caa4&scoped=true"
import script from "./ProjectGateCheckIns.vue?vue&type=script&lang=js"
export * from "./ProjectGateCheckIns.vue?vue&type=script&lang=js"
import style0 from "./ProjectGateCheckIns.vue?vue&type=style&index=0&id=0489caa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489caa4",
  null
  
)

export default component.exports